// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".open-response-answer--openResponseAnswer--1dJ3yBZ6 .open-response-answer--icon--2yNGMFhA {\n  text-align: center;\n}\n", ""]);
// Exports
exports.locals = {
	"openResponseAnswer": "open-response-answer--openResponseAnswer--1dJ3yBZ6",
	"icon": "open-response-answer--icon--2yNGMFhA"
};
module.exports = exports;
